import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  ref: "chat-list",
  class: "chat-list"
}
const _hoisted_2 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  action: "#",
  ref: "input-form",
  id: "input-form"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.getVisibleMessages(), (message, i) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass('message-bubble chat-' + message.role),
          style: _normalizeStyle(
        message.percent != undefined && message.percent < 100 && $setup.isLastMessage(i)
          ? $setup.loadingStyle
          : ''
      )
        }, [
          (message.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1 /* CACHED */)
              ]))]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                innerHTML: $setup.md.render(message.content)
              }, null, 8 /* PROPS */, _hoisted_3))
        ], 6 /* CLASS, STYLE */))
      }), 256 /* UNKEYED_FRAGMENT */)),
      _cache[2] || (_cache[2] = _createElementVNode("li", { style: {"height":"10em","color":"white","box-shadow":"0 0 0 white"} }, null, -1 /* CACHED */))
    ], 512 /* NEED_PATCH */),
    (
      !$setup.store.isPedalling() && $setup.store.getExamplePrompts().length > 0 && $setup.store.examplePromptsVisible
    )
      ? (_openBlock(), _createBlock($setup["PromptExamples"], {
          key: 0,
          onOnSelectPrompt: $setup.setPrompt,
          "user-inputting": $setup.userInput
        }, null, 8 /* PROPS */, ["user-inputting"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("form", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        autofocus: "",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.textInput) = $event)),
        placeholder: 
        $setup.i18n($setup.store.getExamplePrompts().length > 0 ? 'CHAT_PLACEHOLDER_PROMPTS' : 'CHAT_PLACEHOLDER')
      ,
        onInput: $setup.inputting,
        ref: "chatInput"
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5), [
        [_vModelText, $setup.store.textInput]
      ]),
      _createElementVNode("button", {
        onClick: $setup.send,
        type: "submit",
        disabled: $setup.store.isPedalling(),
        class: _normalizeClass({ disabled: $setup.store.isPedalling() })
      }, [
        ($setup.store.isPedalling())
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "visually-hidden" }, "...", -1 /* CACHED */)
            ]))]))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "⬆︎"))
      ], 10 /* CLASS, PROPS */, _hoisted_6)
    ], 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}